import { api } from 'api/axios';
import { Module } from '../types/subject';

export const moduleApi = {
    getAll: async (subject_id: string) => {
        const response = await api.get<{ data: Module[] }>('/modules', {
            params: {
                subject_id
            }
        });
        return response.data;
    },

    getById: async (id: string) => {
        const response = await api.get<{ data: Module }>(`/modules/${id}`);
        return response.data;
    },

    getBySlug: async (slug: string) => {
        const response = await api.get<{ data: Module }>(`/modules/slug/${slug}`);
        return response.data;
    },

    create: async (data: Partial<Module>) => {
        const response = await api.post<{ data: Module }>('/modules', data);
        return response.data;
    },

    update: async (id: string, data: Partial<Module>) => {
        const response = await api.patch<{ data: Module }>(`/modules/${id}`, data);
        return response.data;
    }
};
